import { observer } from 'mobx-react'
import './cookie.scss'
import { ReactComponent as Close } from '../../assets/close.svg'
import { useEffect, useState } from 'react'
import ContentState from '../../stores/ContentState'
import Cookies from 'js-cookie'

const Cookie = observer(() => {
  const [isShow, setShow] = useState(false)
  useEffect(() => {
    if (!ContentState.home?.cookies) return
    if (!Cookies.get('hideModal')) {
      setTimeout(() => {
        setShow(true)
      }, 1300)
    }
  }, [ContentState.home?.cookies])

  useEffect(() => {
    if (isShow) {
      document.querySelector('.cookie')?.classList.add('anim')
    } else {
      document.querySelector('.cookie')?.classList.remove('anim')
    }
  }, [isShow])

  const accept = () => {
    document.querySelector('.cookie')?.classList.remove('anim')

    if (document.cookie.length) {
      Cookies.set('hideModal', 'true', { expires: 7 })
    } else {
      Cookies.set('hideModal', 'true', { expires: 7 })
    }
    setShow(false)
  }

  const cookie: any = ContentState.home?.cookies

  return (
    <section className={isShow ? 'cookie shown' : 'cookie'}>
      <div className="cookie__container">
        <div className="cookie__top">
          <Close className="cookie__close" onClick={() => setShow(false)} />
        </div>
        <div className="cookie__content">
          <div
            className="cookie__text"
            dangerouslySetInnerHTML={{
              __html: cookie?.title,
            }}
          ></div>
          <button className="cookie__accept-btn button black" onClick={accept}>
            {cookie?.button}
          </button>
        </div>
      </div>
    </section>
  )
})

export default Cookie
